/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchSyncTopicEntitiesClientRequest} from '@cash-web/protos/squareup/cash/syncentitygateway/api/v1/app.pb'
import {BatchSyncTopicEntitiesClientResponse} from '@cash-web/protos/squareup/cash/syncentitygateway/api/v1/app.pb'


export const batchTopicSync = (request: BatchSyncTopicEntitiesClientRequest, options?: CashRequestOptions) => post<BatchSyncTopicEntitiesClientRequest, BatchSyncTopicEntitiesClientResponse>("/cash-app/syncentitygateway/v1/batch-topic-sync", request, {...options, rejectOnError: true })